import React from 'react';

import InputBase, {InputBaseProps} from '@material-ui/core/InputBase';

import styles from './BootstrapTextField.module.css';


const BootstrapInput = (props: InputBaseProps) => {

  return (
    <InputBase
      classes={styles}
      {...props}
    />
  )
};

export default React.memo(BootstrapInput);